import { Input } from "../../../@client/api"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"

export function useGetUserAuthenticationFactors(
  input: Input["/api/UserAuthenticationFactor/GetUserAuthenticationFactors"]
) {
  return useSuspenseQueryGet(
    "/api/UserAuthenticationFactor/GetUserAuthenticationFactors",
    input
  )
}
